
<template>
  <div class="apply_state" :class="{'waiting':applyState.state==0,'agree':applyState.state==1,'disagree':applyState.state==2}">
    <span class="apply_icon" :class="{'el-icon-time':applyState.state==0,'el-icon-success':applyState.state==1,'el-icon-warning':applyState.state==2}"></span>
    <p class="state_text">{{applyState.state==0?$t('m.reviewing'):applyState.state==1?$t('m.review_pass'):$t('m.review_failed')}}</p>
    <div class="reson" v-if="applyState.state==0">
      <p v-html="$t('m.your_profile_submit_success')"></p>
    </div>
    <div class="reson" v-else-if="applyState.state==1">      
      <div>
        {{$t('m.success_agency')|filrHtml(0)}}
        <el-button type="primary" @click="workbench()" size="mini">{{$t('m.success_agency')|filrHtml(1)}}</el-button>
        {{$t('m.success_agency')|filrHtml(2)}}
      </div>
    </div>
    <div class="reson" v-if="applyState.state==2">
      <p v-html="$t('m.your_profile_approved',{'msg_ss':applyState.rejectReason})"></p>
      <p><span class="el-icon-arrow-left fc-color-main fc-pointer" @click="resetForm">{{$t('m.return_refill')}}</span></p>
    </div>
    
  </div>
</template>

<script>

import { checkMe } from '@/api/apply';
  export default {
    name:'apply-result',  
    props:{
      applyState: {
        type: Object,
        default () {
          return {};
        }
      },
    },
    data() {
      return {
        dialogFormVisible:true,
        // applyState:{
        //   guildId:null,
        //   state:0,//0：待审核，1：通过，2：未通过	
        //   rejectReason:null
        // },
      }
    },
    filters:{
      filrHtml(val,t){
        let arr=val.split(/【|\[/gi)
        let txt1=arr[0];
        let arr2=arr[1].split(/】|\]/gi)
        let txt2=arr2[0];
        let txt3=arr2[1];
        let returnTxt;
        if(t==0){
          returnTxt=txt1;
        }else if(t==1){
          returnTxt=txt2;
        }else if(t==2){
          returnTxt=txt3;
        }
        return returnTxt;
      }
    },
    mounted(){
    },
    methods:{
     resetForm(){
       this.$emit('updateStepActive',0);
     },
     workbench(){

       checkMe().then(({data}) => {
           let userinfo=this.$store.state.userInfo;
            userinfo.status=3;
            localStorage.setItem('userInfo', JSON.stringify(userinfo))
            this.$router.push({
              name: 'my-guild-detail-page',
              params:{
                first:1,
              }
            });
        })
        .catch(error => {
            
        });      
     },
    },
  };
</script>
<style lang="scss" scoped>
.apply{
  &_state{
    width: 75%;
    margin: 40px auto;
    padding: 20px;
    text-align: center;
    box-sizing: border-box;
    border:1px dashed #008AFF;
    font-size: 14px;
    &.waiting{
      color: #008AFF;
      border-color: #008AFF;
    }
    &.agree{
      color: #67C23A;
      border-color: #67C23A;
    }
    &.disagree{
      color: #E6A23C;
      border-color: #E6A23C;
    }
    .reson{
      color: #333;
      //font-size: 14px;
      line-height: 1.5;
      p{margin: 5px 0;}
    }
  }
  &_icon{
    font-size: 1rem;
  }
}
.state_text{
  font-size: 18px;
  margin: 10px 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/apply/components/applyResult.vue